import { useController } from 'react-hook-form';
import Box from '@/components/Unistyles/Box';
import Text from '@/components/Unistyles/Text';
import TextInput from '@/components/Unistyles/TextInput';
import { MAXIMUM_EVENT_TITLE_LENGTH } from '@/utils/constants';

function EventEditInputTitle() {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: 'title',
  });
  return (
    <Box space="xs">
      <TextInput
        nativeID="composer"
        onChangeText={field.onChange}
        value={field.value}
        placeholder="Title"
        autoCapitalize="words"
        enterKeyHint="done"
        testID="EventEditInputTitle"
        maxLength={MAXIMUM_EVENT_TITLE_LENGTH}
      />
      {error ? (
        <Text variant="warning" size="xs">
          {error.message}
        </Text>
      ) : null}
    </Box>
  );
}
export default EventEditInputTitle;
